import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import TwoFactorEnforcementGuard from './2fa-enforcement-guard';
import { PUBLIC_ROUTES } from './public-routes';

import { nodeAuthApi } from '~c/services';

interface Props extends React.PropsWithChildren {}

const AuthRoute: React.FC<Props> = ({ children }) => {
  const { data: user, isLoading } = nodeAuthApi.useCurrentUserQuery();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          width: '100%',
          bgcolor: 'background.default',
          color: 'text.primary',
          gap: 2,
        }}
        aria-busy
        aria-label="Loading"
      >
        <CircularProgress size={48} color="primary" />
        <Typography variant="body2" color="text.secondary">
          Loading…
        </Typography>
      </Box>
    );
  }

  if (user == null) {
    return (
      <Navigate to={PUBLIC_ROUTES.signIn} state={{ from: location }} replace />
    );
  }

  return <TwoFactorEnforcementGuard>{children}</TwoFactorEnforcementGuard>;
};

export default AuthRoute;
